export class DefinitionTypeBC {
    public static BCStandard = "BCS";
    public static BCEnveloppe = "BCE";

    public static getTypeFromName(name: string[]) {
        for (let key in DefinitionNamesBC) {
            if (DefinitionNamesBC[key] === name) {
                return DefinitionTypeBC[key];
            }
        }
        return name;
    }

    public static typesBCNamesToTypes(names: string[]) {
        if (names == null) {
            return null;
        }
        names = names.map(nom => {
            for (let key in DefinitionNamesBC) {
                if (DefinitionNamesBC[key] === nom) {
                    return DefinitionTypeBC[key];
                }
            }
            return nom;
        });
        return names;
    }
}

export class DefinitionNamesBC {
    public static BCStandard = "simple";
    public static BCEnveloppe = "enveloppe";

    public static getNameFromType(type: string[]) {
        for (let key in DefinitionTypeBC) {
            if (DefinitionTypeBC[key] === type) {
                return DefinitionNamesBC[key];
            }
        }
        return type;
    }
    
    public static typesBCTypesToNames(types: string[]) {
        if (types == null) {
            return null;
        }
        types = types.map(type => {
            for (let key in DefinitionTypeBC) {
                if (DefinitionTypeBC[key] === type) {
                    return DefinitionNamesBC[key];
                }
            }
            return type;
        });
        return types;
    }
}

export class DefinitionIconBC {
    public static BCStandard = "simple";
    public static BCEnveloppe = "enveloppe";
}